var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.asset)?_c('div',{ref:"holder",staticClass:"holder"},[_c('img',{attrs:{"src":_vm.thumbnail.url}})]):_vm._e(),_vm._v(" "),_vm._m(0)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"helper-text"},[_c('i',{staticClass:"fa fa-zoom"}),_vm._v(" Hover to zoom")])}]
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a9f297a","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/Components/Elements/ImageZoom.vue
// module id = 1kd2
// module chunks = 0